import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
// Service
import { BroadcastEventModel, BroadcastService } from '@cv-invision/core';
import { ViewsService } from '../../../../../services/views.service';
import { LayoutRenderService } from '../../../services/layout-render.service';
// Model
import { FORM_EVENT, PHOTO_SELECT_STATUS } from '../../../../../models/enums.model';
import { SelectPhotoResponse } from '../../../../../models/views-service.model';
import { DynamicInterface } from '../../../../models/dynamic.interface';
import { LayoutComponentBroadcast, LayoutRenderLayoutItem } from '../../../models/cv-layout-render.model';
import { TabsEventType } from '../../models/component.events';
// Component
import { Lightbox } from 'ngx-lightbox';

@Component({
	selector: 'cv-schema-render-photo-list-selected',
	templateUrl: './photo-list-selected.component.html'
})
export class PhotoListSelectedComponent implements OnInit, OnDestroy, DynamicInterface {
	@Input() data: any;
	@Input() layoutNode = new LayoutRenderLayoutItem();

	markForCheck: boolean;
	thisData: any;
	photos: any;
	options: any;
	path: string | null;
	public album = [];

	get photosSelected(): any {
		return this.viewsService.photosSelected;
	}

	get flattenedPhotos(): any {
		return this.viewsService.flattenedPhotos;
	}

	protected atComponentDestroy = new Subject();

	constructor(
		private viewsService: ViewsService,
		private layoutRenderService: LayoutRenderService,
		private broadcastService: BroadcastService,
		private lightbox: Lightbox
	) {
		this.broadcastService
			.onEvent(FORM_EVENT.PHOTO_SELECT_ALL_NONE)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((broadcast: BroadcastEventModel) => {
				if (this.album.length > 0) {
					this.album = [];
					this.layoutRenderService.componentBroadcast.next({
						eventType: TabsEventType.GET_ACTIVE_TAB,
						jsonPath: this.path
					});
				}
			});

		this.broadcastService
			.onEvent(FORM_EVENT.PHOTO_SELECT)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((broadcast: BroadcastEventModel) => {
				if ('jsonPath' in broadcast.event && broadcast.event.jsonPath === this.path) {
					const photoId = broadcast.event.data.id;
					const index = this.album.findIndex(img => img.id === photoId);
					this.markForCheck = true;

					if (index > -1) {
						this.updateAlbum(index, broadcast.event.data);
					}
				}
			});
	}

	async ngOnInit(): Promise<void> {
		await this.initializeComponent();
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}

	/**
	 * Initialice component
	 */
	async initializeComponent(): Promise<void> {
		this.options = { ...this.options, ...this.layoutNode.options };

		if (this.options.photosInData) {
			this.photos = this.data.photos;
			this.thisData = this.data.data;
		} else {
			// calculate photos given the path in data
			this.thisData = this.data.data;
		}

		this.path = this.thisData._Path;

		if (this.path) {
			await this.loadImages();
		}
	}

	/**
	 * Wait Changes to the Component if the Component was Mark For Check
	 *
	 * @param changes
	 */
	public async reloadData(init: any): Promise<void> {
		this.data = init.data;
		this.layoutNode = init.layoutNode;

		console.log(init);

		await this.initializeComponent();
	}

	/**
	 * initialize the image variable with the images for certain section.
	 */
	async loadImages(): Promise<void> {
		this.album = [];

		if (this.photos && this.photos.length) {
			this.photos.forEach(img => {
				const image = {
					id: img.id,
					src: img.path,
					thumb: img.thumbnails[0],
					description: img.metadata.description || ''
				};
				this.album.push(image);
			});
		}
	}

	/**
	 * Open lightbox
	 * @param index
	 */
	openGallery(index: any): void {
		this.lightbox.open(this.album, index);
	}

	/**
	 * doc
	 * @param index
	 */
	selectPhoto(index: any, triggerBroadcast?: boolean): void {
		const photoSelected = this.album[index];
		const photoStatus = this.viewsService.selectPhoto(photoSelected.id);

		this.updateAlbum(index, photoStatus);

		if (triggerBroadcast) {
			this.broadcastService.broadcast({
				name: FORM_EVENT.PHOTO_SELECT,
				event: {
					data: photoStatus,
					jsonPath: this.path
				}
			});
		}
	}

	private updateAlbum(index: number, photoStatus: SelectPhotoResponse): void {
		if (photoStatus.status === PHOTO_SELECT_STATUS.UNSELECTED) {
			this.album.splice(index, 1);

			if (this.album.length < 1) {
				const eventData: LayoutComponentBroadcast = {
					eventType: TabsEventType.GET_ACTIVE_TAB,
					jsonPath: this.path,
					metaData: {
						reloadData: true
					}
				}

				this.layoutRenderService.componentBroadcast.next(eventData);
			}
		}
	}

}
